import React, { forwardRef, ForwardRefRenderFunction, useEffect, useState } from 'react'
import { Input } from 'sr/helpers'
import { FormattedMessage } from 'react-intl'
import * as Yup from 'yup'
import { LoaderFullScreen } from 'sr/layout/common/LoaderFullScreen';
interface data {
  email: string;
  password: string;
}
const EmailChange: ForwardRefRenderFunction<any, any> = (props, ref) => {
  
  const [email, setEmail] = useState()
  const [currentPassword, setCurrentPassword] = useState()
  const [errors, setErrors] = useState<any>({});
  const [loader, setLoader] = useState(false)
  const EmailChangeSchema = Yup.object({
    email: Yup.string().email().required('INPUT.VALIDATION.EMAIL'),
    password: Yup.string().required('INPUT.VALIDATION.PASSWORD').min(8, 'INPUT.VALIDATION.PASSWORD.MIN.CHARACTER')
  })

  useEffect(()=>{
      setEmail(props?.data?.email)
  },[props?.data])

  useEffect(()=> {
    props?.HandleData({
      email:email,
      password:currentPassword
    })
  },[email, currentPassword]);

  const validateData = async () =>  {
    setLoader(true)
    const data:data = {
      email:email,
      password:currentPassword,
    }
    let isValid: boolean;
    try {
      await EmailChangeSchema.validate(data, { abortEarly: false });
      setErrors({}); // Reset errors if validation is successful
      props?.HandleData(data);
      isValid = true;
      setLoader(false)
    } catch (validationErrors) {
      setLoader(false)
      const newErrors = {};
      validationErrors.inner.forEach(error => {
        newErrors[error.path] = error.message;
      });
      setErrors(newErrors);
      
      isValid = false;
    }
    setLoader(false)
    return isValid;
  };

  React.useImperativeHandle(ref, () => ({
    validateData
  }));
  return (
    <>
    {loader && <LoaderFullScreen />}
    <Input error={errors?.email}
   onChange={(e:any)=> setEmail(e.target.value)}
   value={email} InputDivClass="mt-0" inputClass = "border border-zinc-800 rounded-lg h-11" label={<FormattedMessage id="INDIVIDUAL.ACCOUNT.SETTINGS.CHANGE_EMAIL.INPUT.NEWMAIL" defaultMessage="New email address" />}></Input>
    <Input onChange={(e:any)=> setCurrentPassword(e.target.value)}
error={errors?.password}
value={currentPassword} type='password' InputDivClass="mt-5" inputClass = "border border-zinc-800 rounded-lg h-11" label={<FormattedMessage id="INDIVIDUAL.ACCOUNT.SETTINGS.INPUT.CURRENTPASS" defaultMessage="Current password" />}></Input>
    </>)
}
export default forwardRef(EmailChange);